import React, { Component, Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default class NotificationPack extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  state = {
    isEditMode: false,
    updatedNotificationPack: {
      schedule: {},
      packName: "",
      amountPerDay: 0,
      amountOfDays: 0,
      amountOfDaysBeforeLeagueStart: 0,
      times: [],
    },
    notifications: [],
  };

  componentDidMount() {
    this.setState({
      updatedNotificationPack: {
        ...this.props.notificationPack,
      },
    });
    this.setState({ notifications: this.props.notifications });
    console.log(this.props.notificationPack);
  }

  handleEditSave = (event, notificationPack, notifications) => {
    event.preventDefault();
    this.setState({ isEditMode: false });
    this.props.handleUpdateNotificationPack(notificationPack, notifications);
    this.setState({ selectedNotifications: [] });
  };

  handleNotificationPackEdit = (event, notificationPack) => {
    event.preventDefault();
    this.setState({
      selectedNotifications: this.state.notifications.filter((notification) =>
        notificationPack.notifications?.includes(notification.id)
      ),
    });
    this.setState({ isEditMode: !this.state.isEditMode });
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      updatedNotificationPack: {
        ...this.state.updatedNotificationPack,
        [name]: value,
      },
    });
  }

  render() {
    return (
      <div className="tile is-near-half is-flex m-small box notification">
        <Fragment>
          <a
            href="/"
            onClick={(e) => {
              this.handleNotificationPackEdit(e, this.props.notificationPack);
            }}
            className="product-edit-icon"
          >
            <FontAwesomeIcon icon="edit" />
          </a>
          <button
            onClick={(event) =>
              this.props.handleDeleteNotificationPack(
                this.props.notificationPack.id,
                event
              )
            }
            className="delete"
          ></button>
        </Fragment>

        {this.state.isEditMode ? (
          <>
            <div className="column is-half">
              <p className="product-id">id: {this.props.notificationPack.id}</p>
              <p>Navn</p>
              <input
                className="input is-medium"
                type="text"
                name="packName"
                value={this.state.updatedNotificationPack.packName}
                onChange={this.handleInputChange}
              />
              <br />
            </div>
            <div className="column is-half">
              <button
                type="submit"
                className="button is-info is-small"
                onClick={(e) => {
                  this.handleEditSave(
                    e,
                    this.state.updatedNotificationPack,
                    this.state.selectedNotifications
                  );
                }}
              >
                Gem
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="column is-half">
              <p className="product-title">
                {this.props.notificationPack.packName}
              </p>
              <p className="product-id">
                <b>id:</b> {this.props.notificationPack.id}
              </p>
              <p className="product-id">
                <b>Antal dage:</b> {this.props.notificationPack.amountOfDays}
              </p>
              <p className="product-id">
                <b>Antal om dagen:</b>{" "}
                {this.props.notificationPack.amountPerDay}
              </p>
              <p className="product-id">
                <b>Antal dage op til ligastart:</b>{" "}
                {this.props.notificationPack.amountOfDaysBeforeLeagueStart}
              </p>
              <p className="product-id">
                <b>Spring system notifikationer over i weekenden:</b>{" "}
                {this.props.notificationPack.skipWeekends ? "Ja" : "Nej"}
              </p>
              <div className="product-id">
                <b>Tidspunkter:</b> <br></br>
                {this.props.notificationPack.times.map((time) => {
                  return (
                    <p key={time + this.state.updatedNotificationPack.id}>
                      {time}
                    </p>
                  );
                })}
              </div>
            </div>

            <div className="column is-half">
              <p className="product-id">
                <b>Notifikationer:</b>
                <br />
              </p>
              {Array.from(
                {
                  length: parseInt(this.props.notificationPack.amountOfDays),
                },
                (_, index) => index + 1
              ).map((day) => {
                const daysBefore = parseInt(
                  this.props.notificationPack.amountOfDaysBeforeLeagueStart
                );
                return (
                  <div key={day}>
                    {daysBefore > 0
                      ? day - 1 < daysBefore
                        ? `${daysBefore - (day - 1)} dage før`
                        : `Dag ${day - daysBefore}`
                      : "Dag " + day}
                    {Array.from(
                      {
                        length: parseInt(
                          this.props.notificationPack.amountPerDay
                        ),
                      },
                      (_, index) => index + 1
                    ).map((time) => {
                      if (
                        !this.props.notificationPack.schedule[
                          this.props.notificationPack.times[time - 1]
                        ]
                      )
                        return;
                      const notificationId =
                        this.props.notificationPack.schedule[
                          this.props.notificationPack.times[time - 1]
                        ][day];
                      if (notificationId) {
                        return (
                          <div key={day + "" + time}>
                            {this.props.notificationPack.times[time - 1]} :{" "}
                            {this.props.notifications.find(
                              (notif) => notif.id == notificationId
                            )?.notificationName ?? "N/A"}
                          </div>
                        );
                      }
                    })}
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    );
  }
}
